const sw = {
  common: {
    dailyLimit: "Umehitimisha kiwango cha kila siku. Tafadhali rudi kesho.",
    loading: "Inapakia...",
    serverError: "Hitilafu ya seva",
  },
  intro: { playNow: "Cheza Sasa", knowMore: "Jua Zaidi" },
  login: {
    fillFields: "Tafadhali jaza sehemu zote!",
    invalid: "Namba si sahihi",
    title: "Ingia kuanza mchezo",
    number: "Weka namba ya simu",
    numberLabel: "Ingiza namba ya simu",
    numberPlaceholder: "Namba ya simu",
    password: "Weka nenosiri",
    login: "Ingia",
    subscribeLink: "Si mtumiaji? Jisajili",
    lowbalance: "Huna salio la kutosha.",
    inprocess: "Uchaji wa huduma unaendelea. Tafadhali subiri kwa muda.",
    invalidNumber: "Weka nambari sahihi ya simu.",
    errorMsg: "Kitu kimeharibika!",
    notSub: "Hakuna usajili uliopatikana",
  },
  register: {
    fillFields: "Tafadhali jaza sehemu zote!",
    title: "Jisajili kuanza mchezo",
    name: "Weka jina",
    number: "Weka namba ya simu",
    numberLabel: "Ingiza namba ya simu",
    numberPlaceholder: "Namba ya simu",
    password: "Weka nenosiri",
    subscribe: "Jisajili",
    loginLink: "Tayari ni mtumiaji? Ingia",
    dailyPass: "Siku",
    dailyDesc: "Gemu masaa 24",
    weeklyPass: "Wiki",
    weeklyDesc: "Siku 7 za upatikanaji wa huduma",
    monthlyPass: "Mwezi",
    monthlyDesc: "Gemu siku 30",
    privacy: "Nyongeza ya Faragha",
    acceptPrivacy: "Tafadhali kubali Nyongeza ya Faragha",
    paymentNote: "Malipo kupitia muda wa maongezi au M-pesa",
    lowbalance: "Huna salio la kutosha.",
    inprocess: "Uchaji wa huduma unaendelea. Tafadhali subiri kwa muda.",
    redirect: "Tafadhali subiri, tunahakiki usajili wako.",
    subSuccess:
      "Utapokea ujumbe wa kuthibitisha usajili, Tafadhali thibitisha.",
    invalidNumber: "Weka nambari sahihi ya simu.",
    alreadySub:
      "Tayari umejisajili kwenye huduma. Ili kufikia huduma, bofya kitufe cha 'Bofya Hapa' hapa chini",
    errorMsg: "Kitu kimeharibika!",
    clickHere: "Bofya Hapa",
    notSub: "Hakuna usajili uliopatikana",
  },
  home: { title: "Viwango vya Mchezo" },
  account: {
    account_subtitle: "Mchezaji wa Hidden Chit",
    pointText: "Jumla ya Pointi",
    currentlevel: "Kiwango cha Sasa",
    gameprogress: "Maendeleo ya Mchezo",
    levelprogress: "Maendeleo ya Kiwango",
    btn: "Acha usajili",
    unsubTitle: "Thibitisha Kujiondoa",
    unsubText:
      "Je, una uhakika unataka kujiondoa kutoka kwa mpango wako wa sasa? Unaweza kupoteza ufikiaji wa michezo ya premium na faida zinazotumika.",
    unsubCancel: "HAPANA",
    unsubConfirm: "NDIYO",
    errorMsg: "Kuna hitilafu!",
    nameUpdated: "Jina limesasishwa!",
    editProfile: "Hariri Wasifu",
    save: "Hifadhi",
    cancel: "Ghairi",
    wheelSpin: "Zungusha Gurudumu",
    locked: "Imefungwa",
    completeLevel10: "Kamilisha Kiwango cha 10",
    alreadySpin: "Umezungusha leo",
    goHome: "Nenda Nyumbani",
    userHistory: "Historia ya Mtumiaji",
  },
  level: {
    level: "Kiwango",
    subtitle: "Tafuta kitu sahihi!",
    tapPuzzle: "Gusa kufungua fumbo",
    puzzleTitle: "Fumbo",
    chooseObj: "Sasa chagua kitu sahihi",
    gameOver: "Mchezo Umeisha",
    usedTries: "Umetumia majaribio yote 2",
    restart: "Anza tena",
    home: "Nyumbani",
    wrong: "Si sahihi! Jaribu tena",
    correct: "Sahihi",
    loading: "Inapakia...",
    silverUnlocked: "Chiti ya Fedha Imefunguliwa!",
    goldenUnlocked: "Chiti ya Dhahabu Imefunguliwa!",
    diamondUnlocked: "Chiti ya Almasi Imefunguliwa!",
    exploreNow: "Chunguza Sasa",
    claimReward: "Pokea Zawadi",
    timeLeft: "Muda Uliosalia",
  },
  history: {
    levelHistory: "Historia ya Viwango",
    spinHistory: "Historia ya Gurudumu",
    goldenTitle: "Zawadi ya Chiti ya Dhahabu",
    diamondTitle: "Zawadi ya Chiti ya Almasi",
    noHistory: "Hakuna historia",
    level: "Kiwango",
    points: "Pointi",
    date: "Tarehe",
    riddle: "Fumbo",
    answer: "Jibu",
    spin: "Zungusha",
    goldenReward: "Zawadi ya Chiti ya Dhahabu",
    reward: "Zawadi",
    goldenRewardLabel: "Zawadi ya Dhahabu",
    type: "Aina",
    diamond: "Almasi",
    noDiamond: "Hakuna zawadi ya almasi",
  },
  silver: {
    wonPrize: "Zawadi Uliyoshinda",
    clickOpen: "Bofya kufungua",
    opening: "Inafungua...",
    spinning: "Inazunguka...",
    spinWheel: "Zungusha Gurudumu",
    youWon: "Umeshinda",
    nextLevel: "Kiwango Kinachofuata",
  },
  golden: { congrats: "Hongera!", claimPrize: "Pokea Zawadi" },
  diamond: {
    title: "Kumbukumbu ya Almasi",
    claimAll: "Pokea Zawadi Zote",
    hint: "Bofya bahasha ya almasi kufungua!",
    data: "Data",
    points: "Pointi",
  },
  finish: {
    gameOver: "MCHEZO UMEISHA",
    clickEnvelopes: "Bofya bahasha kuona zawadi",
    screenshotTip: "Piga picha na shiriki ushindi wako na marafiki!",
    allCollected: "YOTE YAMEKUSANYWA!",
    finalText:
      "Umekusanya hazina zote. Angalia akaunti yako kwa jumla ya salio!",
    goAccount: "NENDA AKAUNTI",
    toolLoading: "Kifaa bado kinapakia...",
    victory: "Ushindi!",
    shareText: "Nimeshinda katika Hidden Chit Game!",
  },
  levelMap: {
    subHeader: "Kamilisha viwango vyote 50 na fungua zawadi!",
    silver: "Chiti ya Fedha",
    golden: "Chiti ya Dhahabu",
    diamond: "Chiti ya Almasi",
    trophy: "Kombe",
  },
};

export default sw;
